import { SVG, SVGProps } from './svg'

export function IconSwitchVertical(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="m10.6 17.9 3 3c.2.1.6.1.8 0l3-3a.5.5 0 0 0-.4-1h-2V9.6c0-.3-.2-.5-.5-.5h-1c-.3 0-.5.2-.5.5V17h-2a.5.5 0 0 0-.4.9Zm.4-11v7.6c0 .3-.2.5-.5.5h-1a.5.5 0 0 1-.5-.5V7H7a.5.5 0 0 1-.3-.9l3-3h.7l3 3a.5.5 0 0 1-.4.9h-2Z" />
    </SVG>
  )
}
